import React from 'react';
import { Grid, Box } from '@mui/material';
import StyledBox from 'views/rebranded-module/location-module/LocationViewV2/components/AboutSection/AboutSection.styles';
import {
  ExpandableDescriptionV2,
  ImgBox,
  Typography700,
} from 'views/rebranded-module/common/components';

const AboutSection = (props) => {
  const {
    title, image, desc, content,
  } = props;
  return (
    <StyledBox>
      <Grid container spacing={8}>
        <Grid item xs={12} md={12} lg={6}>
          <Typography700 variant="h3" component="p" mb={3}>
            {title}
          </Typography700>
          <ExpandableDescriptionV2
            description={desc}
            collapsedSize={475}
            content={content}
          />
        </Grid>
        <Grid item xs={12} md={12} lg={6}>
          <Box className="ASImageContainer">
            <ImgBox
              image={{
                src:
                  image
                  || '/imgs/Rebranding/location-module/about-location-defult.jpg',
                alt: title,
              }}
              width="100%"
              height="100%"
              unoptimized
            />
          </Box>
        </Grid>
      </Grid>
    </StyledBox>
  );
};
export { AboutSection };
